import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import SvgIcon from '@material-ui/core/SvgIcon';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function InsuranceCompaniesIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill={props.fill}  xmlns="http://www.w3.org/2000/svg">
			<path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M12 3C12.5523 3 13 2.55228 13 2C13 1.44772 12.5523 1 12 1C11.4477 1 11 1.44772 11 2C11 2.55228 11.4477 3 12 3ZM21 3C21.5523 3 22 2.55228 22 2C22 1.44772 21.5523 1 21 1C20.4477 1 20 1.44772 20 2C20 2.55228 20.4477 3 21 3Z" fill={props.fill} />
			<path fillRule="evenodd" clipRule="evenodd" d="M20 15C21.1045 15 21.9872 14.1042 21.8488 13.0083C21.3885 9.36556 19.5271 2 12 2C4.47281 2 2.61146 9.36557 2.15118 13.0083C2.01272 14.1042 2.8954 15 3.99997 15H11V20C11 20.8284 10.3284 21.5 9.5 21.5C8.67157 21.5 8 20.8284 8 20V19.5C8 18.9477 7.55228 18.5 7 18.5C6.44772 18.5 6 18.9477 6 19.5V20C6 21.933 7.567 23.5 9.5 23.5C11.433 23.5 13 21.933 13 20V15H20Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<InsuranceCompaniesIcon fill={props.fill} />
		</div>
	);
}